import React from "react";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { Form, Transfer } from "antd";
import { INPUT_TYPES } from "constants/input-types";
import PropTypes from "prop-types";
import { OrderedMap } from "immutable";
import "styles/form.css";

const FormItem = Form.Item;
const addGroupForm = new OrderedMap({
    group_name: {
        type: INPUT_TYPES.TEXT,
        label: "Group Name",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    }
});

class AddGroupForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    render() {
        return (
            <Form>
                <div className={"form-row"}>
                    {addGroupForm
                        .map((field, fieldName) =>
                            this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )()
                        )
                        .toList()
                        .toJS()}
                    <FormItem>
                        <Transfer />
                    </FormItem>
                </div>
            </Form>
        );
    }
}

AddGroupForm.propTypes = {
    form: PropTypes.object
};

export default Form.create({})(AddGroupForm);
